import React from 'react';
import { CtaButton } from './CtaButton';
const chips = ['6 Volumes', '142 Practice Cards', '5 Bonuses', 'Flag 5v5 · 7v7', 'Youth Tackle'];
const micro = ['Instant PDF download', 'Print it and coach from the clipboard', 'No app, no subscription'];
export function Hero() {
  return <section className="w-full bg-navy-deep" data-id="element-104" data-mp="4mi3tby6fqf0">
      <div className="max-w-6xl mx-auto px-5 pt-6 pb-16 sm:pt-10 sm:pb-20" data-id="element-105" data-mp="4jm5hmif2zq1">
        <div className="grid items-center gap-10 lg:grid-cols-[1fr_1fr] lg:gap-14" data-id="element-106" data-mp="128yxm77pblw0">
          <div data-id="element-107" data-mp="xbfm3f2e1n7r">
            <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-108" data-mp="xaxejma9zmkj">
              The season-ready system for flag &amp; youth football coaches
            </p>
            <h1 className="mt-3 font-display font-bold uppercase text-white text-4xl leading-[.91] tracking-tight sm:text-6xl md:text-7xl" data-id="element-109" data-mp="nb6lzq59zhn3">
              Tomorrow&apos;s practice is{' '}
              <span className="text-gold" data-id="element-110" data-mp="3825y4q50c7ld">already planned.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-white/75" data-id="element-111" data-mp="3j8sfs1yzrlqd">
              Sideline Ready is a six-volume system: 142 Practice Cards, each one
              a full session built with The 4-Quarter Practice — by age and
              format, flag 5v5, 7v7 and youth tackle, with game-week plans. Not
              blank templates to fill in. The practice itself, ready to print and
              run.
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-112" data-mp="30gztsricb0s5">
              {chips.map(chip => <li key={chip} className="rounded-full border border-navy-line px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-white/70" data-id="element-113" data-mp="359szbhlmud5a">
                  {chip}
                </li>)}
            </ul>
          </div>

          <div className="relative mx-auto w-full max-w-xl lg:max-w-none" data-id="element-114" data-mp="2hk85g3nxxvh8">
            <div className="overflow-hidden rounded-2xl border border-navy-line bg-navy-mid shadow-card" data-id="element-115" data-mp="2lla6mq1f4hlu">
              <img src="https://cdn.magicpatterns.com/uploads/e7WqwcBY3SB45FTAecywfQ/Professional-product-photography-of-a-co.png" alt="Los seis volúmenes de Sideline Ready apoyados sobre el césped de una cancha de fútbol americano al atardecer, con jugadores entrenando de fondo" width={1024} height={688} loading="eager" decoding="async" fetchPriority="high" className="block h-auto w-full" data-id="element-116" data-mp="s2b9g2qj4r79" />
            </div>
            <span className="absolute -right-2 -top-3 rotate-[6deg] rounded-full bg-gold px-3 py-1 font-display text-[11px] font-bold uppercase tracking-widest text-gold-ink shadow-card" data-id="element-117" data-mp="15zq0fbwfl71c">
              Same order, every week
            </span>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center" data-id="element-118" data-mp="3luia4t2z73mf">
          <div className="w-full max-w-md" data-id="element-119" data-mp="3hqu269afm60n">
            <CtaButton data-id="element-120" data-mp="3hpsg79rvnz45">Get Sideline Ready</CtaButton>
          </div>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-121" data-mp="1xa447fpd2mk5">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-122" data-mp="21b629t7jkskj">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-123" data-mp="268y69llgo553" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}